const DAY_LABELS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const DAY_MS = 24 * 60 * 60 * 1000;

export const VISIT_STRIP_DAYS = 7;

export interface StripDay {
  /** Plain "YYYY-MM-DD", the same shape as VisitEntry.date. */
  date: string;
  day: number;
  label: string;
}

// Plain calendar dates, done in UTC so no local timezone or DST change can
// shift a day.
function toUtc(date: string): number {
  return Date.parse(`${date}T00:00:00Z`);
}

function fromUtc(ms: number): string {
  return new Date(ms).toISOString().slice(0, 10);
}

export function addDays(date: string, days: number): string {
  return fromUtc(toUtc(date) + days * DAY_MS);
}

export function todayDate(now = new Date()): string {
  const local = new Date(now.getTime() - now.getTimezoneOffset() * 60_000);
  return local.toISOString().slice(0, 10);
}

/** The strip's days, oldest on the left, ending (on the right) at `end`. */
export function stripEndingAt(end: string): StripDay[] {
  return Array.from({ length: VISIT_STRIP_DAYS }, (_, i) => {
    const ms = toUtc(end) - (VISIT_STRIP_DAYS - 1 - i) * DAY_MS;
    const d = new Date(ms);
    return { date: fromUtc(ms), day: d.getUTCDate(), label: DAY_LABELS[d.getUTCDay()] };
  });
}
